var _style, _path, _defs, _path2, _path3, _path4, _path5, _defs2, _path6, _path7, _path8, _path9, _polygon, _polygon2, _circle, _path10, _path11, _ellipse, _rect, _g, _path12, _polygon3, _polygon4, _circle2, _path13, _path14, _ellipse2, _rect2, _ellipse3, _rect3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.44;fill:#FDDFFF;}\r\n\t.st1{opacity:0.7;clip-path:url(#SVGID_00000150820671787244226590000003701011391651551112_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_00000148660881874930005370000009887774403202165155_);}\r\n\t.st4{opacity:0.7;clip-path:url(#SVGID_00000083785927821371792750000017009153715687676856_);}\r\n\t.st5{fill:url(#SVGID_00000033343093158884540440000014515534373529709479_);}\r\n\t.st6{fill:url(#SVGID_00000034808316652727116840000009857633284403730358_);}\r\n\t.st7{fill:url(#SVGID_00000143611998743579063900000015996491739983483779_);}\r\n\t.st8{fill:url(#SVGID_00000120548676648798601400000013939777922572992165_);}\r\n\t.st9{opacity:0.25;fill:url(#SVGID_00000045592875956091920710000007642976353567362992_);}\r\n\t.st10{fill:url(#SVGID_00000054958684976553726980000017386587336115252669_);}\r\n\t.st11{fill:url(#SVGID_00000044149393911558250290000000956601433798376381_);}\r\n\t.st12{fill:url(#SVGID_00000050640345692607882550000016969012771763592603_);}\r\n\t.st13{fill:url(#SVGID_00000002382227909181891600000016257306704661342902_);}\r\n\t.st14{fill:url(#SVGID_00000123408602324222597530000005865673145813727902_);}\r\n\t.st15{fill:url(#SVGID_00000069385178357396152690000012065728702101484704_);}\r\n\t.st16{fill:url(#SVGID_00000035516884272151330390000011239741436413209523_);}\r\n\t.st17{fill:#F4F7FA;}\r\n\t.st18{fill:url(#SVGID_00000153669067315002795590000002103552623640968865_);}\r\n\t.st19{fill:url(#SVGID_00000182516682603836565690000008811127502732648607_);}\r\n\t.st20{opacity:0.25;fill:url(#SVGID_00000014595648200696962960000004296864408203136441_);}\r\n\t.st21{fill:url(#SVGID_00000052100229806922489470000001597490036362492818_);}\r\n\t.st22{opacity:0.25;fill:url(#SVGID_00000023251757077069375420000005910037882443624622_);}\r\n\t.st23{fill:url(#SVGID_00000098218525806157087220000006563332128145552830_);}\r\n\t.st24{fill:url(#SVGID_00000093179105734212127120000000059811596946901123_);}\r\n\t.st25{fill:url(#SVGID_00000088827133919402953850000006004168449324929160_);}\r\n\t.st26{opacity:0.5;fill:#EFF0EF;}\r\n\t.st27{opacity:0.7;fill:#FFFFFF;}\r\n\t.st28{fill:url(#SVGID_00000033330324067945138480000000310630761290380205_);}\r\n\t.st29{fill:url(#SVGID_00000145032525740787213380000000955349074202295207_);}\r\n\t.st30{fill:url(#SVGID_00000008138149363013193320000002338764194199417489_);}\r\n\t.st31{fill:url(#SVGID_00000160878900843012283090000006160713884066739372_);}\r\n\t.st32{opacity:0.25;fill:url(#SVGID_00000083090800816607802520000003926405326014515856_);}\r\n\t.st33{fill:url(#SVGID_00000140000906105170409810000012498976878370602158_);}\r\n\t.st34{fill:url(#SVGID_00000014601685718286035460000007291770830189936526_);}\r\n\t.st35{fill:url(#SVGID_00000141440302944684169700000001825916521432193202_);}\r\n\t.st36{opacity:0.4;fill:#FFFFFF;}\r\n\t.st37{fill:url(#SVGID_00000041989034968882419310000012505567689044697533_);}\r\n\t.st38{fill:url(#SVGID_00000126310082744543831850000012347092824847446656_);}\r\n\t.st39{fill:url(#SVGID_00000061469431940017114010000004348382700136317610_);}\r\n\t.st40{fill:url(#SVGID_00000041996535683664448680000007493055640945900188_);}\r\n\t.st41{fill:url(#SVGID_00000145017124132190824340000004691950794503977381_);}\r\n\t.st42{fill:url(#SVGID_00000003106909897202976800000017244509130193896339_);}\r\n\t.st43{fill:url(#SVGID_00000142865127849991650690000017243024703407664776_);}\r\n\t.st44{opacity:0.3;fill:url(#SVGID_00000064352870314431920520000008673979335171987348_);}\r\n\t.st45{fill:url(#SVGID_00000167371892463539803260000016249881467945928085_);}\r\n\t.st46{fill:url(#SVGID_00000058557368044445935400000001281036966106482058_);}\r\n\t.st47{fill:url(#SVGID_00000160184469902090345180000015431399042716387230_);}\r\n\t.st48{fill:url(#SVGID_00000082359497794531919530000015501259297810634932_);}\r\n\t.st49{fill:url(#SVGID_00000086669547604549619790000011397481977230155967_);}\r\n\t.st50{fill:url(#SVGID_00000158014224115724594870000001326539702394711223_);}\r\n\t.st51{fill:url(#SVGID_00000013171215176364262900000013201285372734886535_);}\r\n\t.st52{fill:url(#SVGID_00000148646353908978408120000014574733812836495786_);}\r\n\t.st53{fill:url(#SVGID_00000012467349702564906830000011609967985302094767_);}\r\n\t.st54{fill:url(#SVGID_00000177461658272596491630000017065668913615713167_);}\r\n\t.st55{fill:url(#SVGID_00000155122500190572478490000003193489955382117028_);}\r\n\t.st56{opacity:0.25;fill:url(#SVGID_00000169527819869169696160000005931327813447795135_);}\r\n\t.st57{fill:url(#SVGID_00000119840081701696524560000006427739874197686917_);}\r\n\t.st58{fill:url(#SVGID_00000165955065138977656420000005758002662446159783_);}\r\n\t.st59{fill:url(#SVGID_00000171695934716207255010000003097612117902367371_);}\r\n\t.st60{fill:url(#SVGID_00000044897361906899282560000003747503674626102147_);}\r\n\t.st61{fill:url(#SVGID_00000165948273285098542630000015185165262642900890_);}\r\n\t.st62{fill:url(#SVGID_00000109714884450549110100000011965302902506383532_);}\r\n\t.st63{fill:url(#SVGID_00000045587640356490303720000005926855792876600502_);}\r\n\t.st64{fill:url(#SVGID_00000023980769179422585280000006716953319404026002_);}\r\n\t.st65{fill:url(#SVGID_00000138570089586211159310000012425016215318599315_);}\r\n\t.st66{opacity:0.25;fill:url(#SVGID_00000181803816881477938490000004578214141321448883_);}\r\n\t.st67{fill:url(#SVGID_00000173853105998171962070000008045935947233375616_);}\r\n\t.st68{opacity:0.25;fill:url(#SVGID_00000132080355857655648910000000887601844122937482_);}\r\n\t.st69{fill:url(#SVGID_00000111173984374976404510000000256773375051957380_);}\r\n\t.st70{fill:url(#SVGID_00000028311650641888967830000013014170681699904130_);}\r\n\t.st71{fill:url(#SVGID_00000049913955968441589390000013578190498011931818_);}\r\n\t.st72{fill:url(#SVGID_00000144297244345280602460000005597199076268735365_);}\r\n\t.st73{fill:url(#SVGID_00000119080930800489890150000006198975327868414890_);}\r\n\t.st74{opacity:0.25;fill:url(#SVGID_00000155828448073138477560000006795814256752296618_);}\r\n\t.st75{fill:url(#SVGID_00000021816773555870213350000011248821918937071508_);}\r\n\t.st76{fill:url(#SVGID_00000167355323677473507110000006701084729762637217_);}\r\n\t.st77{fill:url(#SVGID_00000059287027369236545130000006451270443190266792_);}\r\n\t.st78{fill:url(#SVGID_00000019656075013064278260000008173456709991862971_);}\r\n\t.st79{fill:url(#SVGID_00000026149058031115077990000001838469273288854951_);}\r\n\t.st80{fill:url(#SVGID_00000106867198871437037430000012429218771501331883_);}\r\n\t.st81{fill:url(#SVGID_00000037690868422860109350000015093431387552158102_);}\r\n\t.st82{fill:url(#SVGID_00000075157165197264996300000001968314801159984306_);}\r\n\t.st83{fill:url(#SVGID_00000010993274136416616330000001226578666690242750_);}\r\n\t.st84{fill:url(#SVGID_00000065760170339938521530000017531049985106223246_);}\r\n\t.st85{opacity:0.3;}\r\n\t.st86{fill:url(#SVGID_00000045596060640346551030000001962410793223140756_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.3,52.3c2.3-27.2-24.6-36-43.3-28.5c-2.9,1.1-2.7,0.6-10.6,2.6C42.8,33,40,30.3,33.6,33.7 c-22.8,12.2-15.4,61.9-13.3,71.2c0.8,3.6,2.6,11.5,9.1,17.8c0.1,0.1,1.9,1.9,4.2,3.4c6,3.9,18.9,8,61.6,5.1 c11.8-0.8,22-0.1,31.8-18.8C136.8,93.8,122,79.5,124.3,52.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M99.4,100.7c-2.9-3-6.9-8-7.5-14.7c-1-11.6,9.7-15,11.8-29.7c1.8-11.8-4.2-15.9-0.1-25.8 c0.7-1.7,4.2-10.7,11-11.5c3.8-0.5,6.9,1.9,7.5,2.3c8.9,6.6,9.6,26.2,2.5,40.4c-4.1,8.1-7,8.5-15.6,20.7 C103.9,89.6,101,96.3,99.4,100.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126283176202221213250000012961470183009826952_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.2818,
    y1: 31.1558,
    x2: 97.8214,
    y2: 95.1852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46736E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#2F4F4F"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000126283176202221213250000012961470183009826952_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168808119673411998890000014751305240895460251_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      clipPath: "url(#SVGID_00000168808119673411998890000014751305240895460251_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.1,105.5c-4-9.2-4.6-16.9-1.8-22.7c1.3-2.9,3-4.3,4.7-5.9c1.9-1.7,3.8-3.4,5.4-7 c1.6-3.5,1.4-5.8,1.2-8.7c-0.2-2.6-0.3-5.8,0.6-10.9c0.9-4.5,2-7.1,3-9.4c1.1-2.5,1.9-4.5,2-7.9c0.2-5.7-1.6-11.4-5.5-17.1 l0.1-0.1c3.9,5.7,5.8,11.5,5.5,17.2c-0.1,3.5-1,5.5-2.1,8c-1,2.3-2.1,4.9-3,9.4c-1,5.1-0.8,8.3-0.6,10.9 c0.2,2.9,0.3,5.2-1.3,8.7c-1.6,3.7-3.6,5.4-5.5,7.1c-1.7,1.5-3.4,3-4.7,5.8c-2.7,5.8-2.1,13.4,1.8,22.6L101.1,105.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.9,42L113.9,42c-0.1-0.2-4.3-14-11.7-15.7l0-0.1c2.2,0.5,5.4,2.4,8.7,8.5c1.8,3.3,2.8,6.5,3,7.1 c6.2-4.1,9.2-9.7,10.5-13.6c1.5-4.3,1.5-7.6,1.5-7.6l0.1,0c0,0,0,3.4-1.5,7.7C123.2,32.2,120.3,37.8,113.9,42L113.9,42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.6,55.8L110.6,55.8c-1.3-3.7-3.9-7.4-5.9-9.9c-2.1-2.7-3.9-4.5-4-4.5l0.1-0.1c0,0,1.9,1.9,4,4.5 c1.9,2.5,4.5,6.2,5.9,9.8c0.5-0.1,4.1-0.9,8.3-3.3c4.2-2.4,9.9-6.9,13.4-14.6l0.1,0.1c-3.5,7.8-9.2,12.3-13.5,14.7 C114.5,55,110.7,55.8,110.6,55.8L110.6,55.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.7,75.5C105.7,75.5,105.7,75.5,105.7,75.5l-0.1,0l0-0.1c0.6-8.5-7.4-16.2-7.5-16.3l0.1-0.1 c0.1,0.1,8.1,7.8,7.5,16.4c0.9,0,10.5-0.3,21.3-8.2l0.1,0.1c-5.9,4.4-11.4,6.4-15,7.3C108.6,75.4,106.1,75.5,105.7,75.5z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125603675485007370440000014768403716920612274_",
    gradientUnits: "userSpaceOnUse",
    x1: -2473.7917,
    y1: 80.0762,
    x2: -2534.073,
    y2: 129.593,
    gradientTransform: "matrix(0.9607 -0.2776 0.2776 0.9607 2484.3093 -707.8181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#799B91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E6764"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125603675485007370440000014768403716920612274_)"
    },
    d: "M97.2,97.9c0.9-2.7,2.6-6.8,5.7-11.1 c5.5-7.8,10-8.6,10.9-13.9c1-5.5-3.3-7.2-2-13.5c0.1-0.5,1.6-7.2,6.3-8.4c3.3-0.9,6.4,1.4,7.9,2.5c5.7,4.1,10.4,13.1,7.5,21.3 c-2.8,7.7-11,10.7-13.6,11.7c-4.6,1.7-6.6,0.8-11.2,2.6C103.1,91.2,99.4,95.1,97.2,97.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020390119409579844000000008380256556690762667_",
    d: "M58.4,109.1c1.3-3.1,2.8-7.9,1.3-13 c-2.7-8.8-11.5-8.2-17.4-18.4c-4.7-8.2-1.5-12.9-7.5-19.1c-1-1-6.2-6.6-11.5-5.3c-2.9,0.8-4.6,3.4-4.9,3.9 c-4.6,7.5,0.6,22.1,10,30.5c5.4,4.8,7.6,4.2,17.6,10.7C51.8,102.2,55.9,106.3,58.4,109.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153694819782906856240000017476019208185173156_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.4033,
    y1: 65.0844,
    x2: 33.3404,
    y2: 98.0917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46736E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#2F4F4F"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020390119409579844000000008380256556690762667_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000153694819782906856240000017476019208185173156_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021102469038137126950000000161062436540125106_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020390119409579844000000008380256556690762667_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      clipPath: "url(#SVGID_00000021102469038137126950000000161062436540125106_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.6,113.1l-0.1,0c0.2-7.9-1.5-13.7-5.2-17.2c-1.8-1.7-3.4-2.3-5.2-2.9c-1.9-0.7-3.8-1.4-6.1-3.6 c-2.2-2.2-2.8-3.9-3.5-6.1c-0.6-1.9-1.4-4.3-3.7-7.8c-2-3.1-3.5-4.6-4.9-6c-1.5-1.5-2.7-2.7-3.8-5.3c-1.8-4.1-2.2-8.9-1-14.3 l0.1,0C24,55.2,24.3,60,26.1,64.1c1.1,2.5,2.3,3.7,3.8,5.2c1.4,1.4,3,3,4.9,6.1c2.2,3.5,3,5.9,3.7,7.9c0.7,2.2,1.3,3.9,3.4,6 c2.2,2.2,4.2,2.9,6,3.6c1.7,0.6,3.4,1.2,5.2,2.9C57,99.3,58.8,105.1,58.6,113.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.6,70.1L30.6,70.1c-6-1.2-9.8-4.5-12-7c-2.3-2.7-3.3-5.2-3.3-5.2l0.1-0.1c0,0,1,2.5,3.3,5.2 c2.1,2.5,5.9,5.7,11.7,6.9c-0.1-1.1-0.6-11.6,4.1-14.9l0.1,0.1C29.7,58.5,30.6,69.9,30.6,70.1L30.6,70.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.5,79.5c-1.1,0-2.4-0.1-3.8-0.3c-3.8-0.5-9.4-2.2-14.2-6.9l0.1-0.1c4.8,4.7,10.4,6.3,14.1,6.9 c3.8,0.5,6.6,0.1,7.1,0c-0.2-5.9,3-13.4,3.1-13.4l0.1,0.1c0,0-0.8,1.9-1.6,4.5c-0.7,2.4-1.5,5.9-1.4,8.9l0,0.1l-0.1,0 C36.9,79.3,35.6,79.5,33.5,79.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.3,93.8c-2.6,0-5.7-0.3-9.2-1.2l0-0.1c10.2,2.7,17.3,0.1,18.1-0.2C43.3,86.1,47,78.1,47,78l0.1,0.1 c0,0.1-3.7,8.1-0.7,14.2l0,0.1l-0.1,0C46.3,92.4,42.9,93.8,37.3,93.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121269636390561742480000005581944972528652192_",
    gradientUnits: "userSpaceOnUse",
    x1: -3970.4604,
    y1: 745.1786,
    x2: -3930.9868,
    y2: 701.8063,
    gradientTransform: "matrix(-0.9477 0.319 0.319 0.9477 -4136.5034 554.3702)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#799B91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E6764"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121269636390561742480000005581944972528652192_)"
    },
    d: "M62.6,95.1c-2.1-1.5-5.5-3.7-10.1-5.4 c-8.2-3-11.9-1.3-15.4-4.7c-3.6-3.6-1.2-7.1-5.5-11.1c-0.4-0.3-4.9-4.6-9.1-3c-2.9,1.1-4.1,4.4-4.6,5.9c-2.1,6-1,15.2,5.4,19.8 c6.1,4.3,13.8,2.3,16.3,1.7c4.3-1.1,5.3-2.8,9.7-3.8C54.7,93.1,59.5,94.1,62.6,95.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144327977373029304490000007815359686491907768_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.365,
    y1: 44.8111,
    x2: 67.8177,
    y2: 188.9584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464143"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144327977373029304490000007815359686491907768_)"
    },
    d: "M122.6,105.7c0,2.1-1.6,3.8-3.7,4 l-58.9,5.5l-22.2,2.1l-0.2,0c-1.1,0.1-2.3-0.1-3.3-0.7l-3.8-2.1c-1-0.5-1.6-1.6-1.6-2.7V54.2l6.7-0.5l86.8-6.1l0,19.7l0.1,34.4 L122.6,105.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054249520917718764920000005754039469292016316_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.7522,
    y1: 121.6352,
    x2: 75.8415,
    y2: 107.3526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054249520917718764920000005754039469292016316_)"
    },
    d: "M122.5,105.7v0.2c0,2.1-1.6,3.8-3.6,4 l-81.1,7.6l-0.2,0c-1.1,0.1-2.3-0.1-3.3-0.7l-3.8-2.1c-1-0.5-1.6-1.6-1.6-2.7v-4.3c0,1.1,0.6,2.2,1.6,2.7l3.8,2.1 c1,0.5,2.1,0.8,3.3,0.7l0.2,0l81.1-7.6c2-0.2,3.5-1.8,3.6-3.8L122.5,105.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141440048180186290190000006538775788369884824_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.3679,
    y1: 56.7754,
    x2: 98.326,
    y2: 122.2164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141440048180186290190000006538775788369884824_)"
    },
    d: "M122.5,67.4c-0.3,1.7-1.8,3-3.6,3.2 l-81.3,7.6c-1.1,0.1-2.3-0.1-3.3-0.7l-3.8-2.1c-1-0.5-1.6-1.6-1.6-2.7V54.2l93.5-6.5L122.5,67.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164511700608710594340000008996483743504115589_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.9892,
    y1: 85.6419,
    x2: 37.8718,
    y2: 85.6419
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3C5CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADA0A6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000164511700608710594340000008996483743504115589_)"
    },
    d: "M37.9,57.3v60.2l-0.2,0 c-1.1,0.1-2.3-0.1-3.3-0.7l-3.8-2.1c-1-0.5-1.6-1.6-1.6-2.7l0.1-57.8l6.6-0.5C36.4,54.6,37.2,55.8,37.9,57.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155108089923886804680000003348314175053435576_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.0364,
    y1: 51.5071,
    x2: 122.5171,
    y2: 51.5071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155108089923886804680000003348314175053435576_)"
    },
    d: "M30.3,56.7c-0.9-0.5-1.4-1.5-1.2-2.5 c0.2-1,1.1-1.8,2.1-1.9l81.6-8.2c2.9-0.3,5.8,0.3,8.3,1.6c1.1,0.6,1.7,1.8,1.4,3c-0.2,1.2-1.2,2.1-2.5,2.2l-78.8,7.9 C37.4,59.2,33.6,58.5,30.3,56.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160871198274580697040000004695271206269549198_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.1912,
    y1: 43.841,
    x2: 88.6327,
    y2: 43.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000160871198274580697040000004695271206269549198_)"
    },
    points: "56.2,49.8 62.9,39.5 81.1,37.9  88.6,46.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019676726761083104990000008135156297335609772_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.0224,
    y1: 42.8211,
    x2: 35.0539,
    y2: 69.2192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019676726761083104990000008135156297335609772_)"
    },
    d: "M37.9,49.9v4h0c0.1,1.2,4,2.3,8.9,2.3 s8.8-1,8.9-2.3h0v-4H37.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000195237749254976200000010435321733932857777_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.9325,
    y1: 49.8386,
    x2: 55.6927,
    y2: 49.8386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000000195237749254976200000010435321733932857777_)"
    },
    cx: 46.8,
    cy: 49.8,
    rx: 8.9,
    ry: 2.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "62.3,56.9 69,46.6 87.2,44.9 94.8,53.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044171413069349634230000004947964974335656850_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.1912,
    y1: 48.1403,
    x2: 69.0355,
    y2: 48.1403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000044171413069349634230000004947964974335656850_)"
    },
    points: "56.2,49.8 62.4,56.7 69,46.6  62.9,39.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000919857907149790680000011105006895036401568_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.2745,
    y1: 45.0479,
    x2: 83.588,
    y2: 64.1256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000000919857907149790680000011105006895036401568_)"
    },
    points: "62.4,56.7 94.8,53.6 96.8,56.3  63.2,59.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182523276253791839310000008651643111905962886_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.1127,
    y1: 66.5152,
    x2: 101.2687,
    y2: 66.5152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000182523276253791839310000008651643111905962886_)"
    },
    points: "63.2,59.9 61.1,76.7 101.3,70.1  96.8,56.3  "
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "60.5,76.7 62.4,56.7 63.2,59.9 61.1,78.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173137893316307395620000003448796147636517303_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.948,
    y1: 37.6198,
    x2: 61.2755,
    y2: 63.6853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000173137893316307395620000003448796147636517303_)"
    },
    points: "60.5,76.7 62.4,56.7 63.2,59.9  61.1,78.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127722609133157613910000012113787942418350739_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.341,
    y1: 62.735,
    x2: 101.4566,
    y2: 120.6335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127722609133157613910000012113787942418350739_)"
    },
    d: "M111.8,84.1c0.5,2.2,0.8,4.4,0.8,6.7 c0,15.4-12.5,27.9-27.9,27.9c-2.7,0-5.2-0.4-7.7-1.1l-2.5,2.4l-2.4-2.4l-6-6c-0.8-0.7-1.5-1.5-2.3-2.3l0,0 c-4.4-4.9-7-11.4-7-18.5c0-5.4,1.6-10.5,4.2-14.8c0,0,0,0,0,0C66,68.2,74.8,63,84.7,63c4,0,7.7,0.8,11.1,2.3 c3.4,1.5,6.5,3.6,9,6.3l9.7,9.7L111.8,84.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092415349765867159800000018440628943627576970_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.8665,
    y1: 96.7968,
    x2: 72.135,
    y2: 96.7968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000092415349765867159800000018440628943627576970_)"
    },
    d: "M72.1,117.6l-6-6 c-0.8-0.7-1.5-1.5-2.3-2.3l0,0c-4.4-4.9-7-11.4-7-18.5c0-5.4,1.6-10.5,4.2-14.8c-0.1,0.3-4.2,15.1,2,19.7 c6.3,4.7,7.2,13,8.7,20.7C71.9,116.8,72,117.2,72.1,117.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051348033087879894570000011131050761158577294_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.3243,
    y1: 101.2711,
    x2: 123.0357,
    y2: 101.2711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464143"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051348033087879894570000011131050761158577294_)"
    },
    d: "M123,101.3c0,11-6.3,20.5-15.6,25 c-3.7,1.8-7.9,2.9-12.3,2.9c-15.4,0-27.9-12.5-27.9-27.9c0-7.6,3.1-14.5,8-19.6c5-5.1,12.1-8.3,19.8-8.3 C110.6,73.4,123,85.9,123,101.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131355652132592587470000001083438647182374563_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.3243,
    y1: 105.4146,
    x2: 107.468,
    y2: 105.4146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000131355652132592587470000001083438647182374563_)"
    },
    d: "M107.5,126.3 c-3.7,1.8-7.9,2.9-12.3,2.9c-15.4,0-27.9-12.5-27.9-27.9c0-7.6,3.1-14.5,8-19.6c3,1.2,6.1,3.9,7.7,9.8 C86.4,103.8,88.8,125.8,107.5,126.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180332698836623428540000006342793282466614717_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.2711,
    y1: 122.5449,
    x2: 102.1011,
    y2: 122.0348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180332698836623428540000006342793282466614717_)"
    },
    d: "M116.5,101.3 c0,11.8-9.5,21.3-21.3,21.3c-6.8,0-12.8-3.1-16.7-8.1c-2.9-3.6-4.6-8.3-4.6-13.3c0-11.8,9.5-21.3,21.3-21.3 c5,0,9.6,1.7,13.3,4.6C113.4,88.5,116.5,94.5,116.5,101.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022537342942428060420000018092767055398494122_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.8578,
    y1: 99.5582,
    x2: 113.0763,
    y2: 99.5582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022537342942428060420000018092767055398494122_)"
    },
    d: "M113.1,97.8 c0,11.8-9.5,21.3-21.3,21.3c-5,0-9.6-1.7-13.3-4.6c-2.9-3.6-4.6-8.3-4.6-13.3c0-11.8,9.5-21.3,21.3-21.3c5,0,9.6,1.7,13.3,4.6 C111.3,88.2,113.1,92.8,113.1,97.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073689839396183444150000005876790977050314401_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.9068,
    y1: 92.3678,
    x2: 83.4169,
    y2: 92.7078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3C5CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADA0A6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000073689839396183444150000005876790977050314401_)"
    },
    cx: 93,
    cy: 99.1,
    r: 10
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 96.1,
    cy: 96.4,
    r: 4.9
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M107.5,63.3c-1.4,0-2.6-1.1-2.7-2.5l0-0.4c-0.1-1.5,1-2.8,2.4-2.9l8.8-0.8c0.1,0,0.2,0,0.2,0 c1.4,0,2.6,1.1,2.7,2.5l0,0.4c0.1,1.5-1,2.8-2.4,2.9l-8.8,0.8C107.6,63.3,107.6,63.3,107.5,63.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.4,59.6c0.1,1.2-0.8,2.2-2,2.4l-8.8,0.8c-1.2,0.1-2.2-0.8-2.4-2l0-0.4c-0.1-1.2,0.8-2.2,2-2.4l8.8-0.8 c1.2-0.1,2.2,0.8,2.4,2L118.4,59.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174569834343828456670000016655277947785906598_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.7458,
    y1: 47.6445,
    x2: 103.7759,
    y2: 47.6445
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000174569834343828456670000016655277947785906598_)"
    },
    cx: 98.3,
    cy: 47.6,
    rx: 5.5,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052093831426620298940000016699184891090963112_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.7458,
    y1: 46.4407,
    x2: 103.7759,
    y2: 46.4407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 92.7,
    y: 45.2,
    style: {
      fill: "url(#SVGID_00000052093831426620298940000016699184891090963112_)"
    },
    width: 11,
    height: 2.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052782836675134013070000005841601408918670991_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.7458,
    y1: 45.181,
    x2: 103.7759,
    y2: 45.181
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000052782836675134013070000005841601408918670991_)"
    },
    cx: 98.3,
    cy: 45.2,
    rx: 5.5,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 111.1,
    cy: 48.9,
    rx: 5.5,
    ry: 1.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 46.5,
    className: "st17",
    width: 11,
    height: 2.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036930611931569737460000006048556270136282259_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.5476,
    y1: 46.4431,
    x2: 116.5777,
    y2: 46.4431
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000036930611931569737460000006048556270136282259_)"
    },
    cx: 111.1,
    cy: 46.4,
    rx: 5.5,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177470758891692991640000012242940103776592292_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.9892,
    y1: 99.3489,
    x2: 60.0727,
    y2: 99.3489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85A0B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#47607E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000177470758891692991640000012242940103776592292_)"
    },
    d: "M60.1,115.2l-22.2,2.1v0.2 l-0.2,0c-1.1,0.1-2.3-0.1-3.3-0.7l-3.8-2.1c-1-0.5-1.6-1.6-1.6-2.7V96.5c6.3-5.6,4.9-18.2,8.8-14.7c0,0,0.8,16.7,8,16.7 s12.8,4.8,14.1,15.9C59.9,114.6,60,114.9,60.1,115.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028303114738272519040000008146354931221349539_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.7584,
    y1: 28.9489,
    x2: 26.0735,
    y2: 33.0291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E115FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#415B7E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000028303114738272519040000008146354931221349539_)"
    },
    cx: 34.2,
    cy: 43,
    r: 14.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166663883844907915700000017598574195366242732_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.7629,
    y1: 24.3252,
    x2: 29.078,
    y2: 30.4455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D34AFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7595B6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000166663883844907915700000017598574195366242732_)"
    },
    cx: 35.3,
    cy: 41.9,
    r: 14.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039822011918099589210000012983311671634922141_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.6045,
    y1: 41.8796,
    x2: 48.9385,
    y2: 41.8796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D63FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7595B6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039822011918099589210000012983311671634922141_)"
    },
    d: "M48.9,41.9c0,7.5-6.1,13.7-13.7,13.7 c-2.7,0-5.2-0.8-7.3-2.1c-3.8-2.4-6.3-6.7-6.3-11.5c0-7.5,6.1-13.7,13.7-13.7c0.1,0,0.3,0,0.4,0C43,28.4,48.9,34.5,48.9,41.9z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "35.3,35.6 23,39.3 35.3,43.1 47.5,39.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.3,44.4L27.5,42v5.4c0,0.9,0.6,1.6,1.5,1.8c4.1,0.9,8.1,0.9,12,0c0.8-0.2,1.4-1,1.4-1.8v-5.2L35.3,44.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.8,46.6c-0.7,0.3-1.3,0.3-1.8,0c-0.1-0.1-0.2-0.3-0.2-0.4l1.1-5.4l1.1,5.4C26.1,46.4,26,46.5,25.8,46.6z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "35.3,38.8 24.8,39.9 24.8,41.7 25.1,41.7 25.2,40.1  "
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M48.9,41.9c0,7.5-6.1,13.7-13.7,13.7c-2.7,0-5.2-0.8-7.3-2.1c1.3-3.5,5-7.2,8.8-9.6 c7.1-4.4,1.7-12.2-1.2-15.6C43,28.4,48.9,34.5,48.9,41.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056399188491983848510000003556182918536819379_",
    gradientUnits: "userSpaceOnUse",
    x1: 4389.5591,
    y1: 71.6052,
    x2: 4386.4258,
    y2: 78.0122,
    gradientTransform: "matrix(-1 0 0 1 4413.8428 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056399188491983848510000003556182918536819379_)"
    },
    d: "M28.4,72.6c-2.3,2.5-7.7,8.5-5.7,12.8 c0.3,0.6,0.6,1.2,1.2,1.5c1.9,0.7,3.5-3.2,7.7-4c2.1-0.4,2.9,0.4,3.6-0.3c2.2-2.1-1.8-11.5-4.9-11.3 C29.7,71.3,29.3,71.6,28.4,72.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139986413771721534770000008601430751033925804_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.9425,
    y1: 265.7986,
    x2: 167.8095,
    y2: 272.2057,
    gradientTransform: "matrix(0.9957 9.230000e-02 -9.230000e-02 0.9957 -91.3738 -207.9537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139986413771721534770000008601430751033925804_)"
    },
    d: "M50.1,73.1c2,2.7,6.9,9.1,4.5,13.3 c-0.3,0.6-0.7,1.2-1.3,1.3c-1.9,0.5-3.2-3.5-7.3-4.7c-2.1-0.6-2.9,0.2-3.6-0.6c-2-2.3,2.9-11.3,6-10.8 C48.9,71.6,49.3,72,50.1,73.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078763640653003143110000013010242042942830227_",
    gradientUnits: "userSpaceOnUse",
    x1: -959.2084,
    y1: 226.157,
    x2: -955.3812,
    y2: 226.157,
    gradientTransform: "matrix(-0.996 8.990000e-02 8.990000e-02 0.996 -935.5738 -8.3829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078763640653003143110000013010242042942830227_)"
    },
    d: "M36.6,130.1c-0.2,0.2-0.2,0.6-0.2,0.9 c0,0.1,0,0.2,0,0.2c0.1,0.3,0.7,0.3,1.7,0.3c1.5,0.1,2,0.2,2.1-0.1c0.1-0.2-0.2-0.6-0.2-0.6c-0.2-0.2-0.4-0.3-0.8-0.4 c-0.7-0.2-1.2-0.3-1.4-0.3C36.8,130,36.7,130,36.6,130.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131329521002501983900000003052932883260080770_",
    gradientUnits: "userSpaceOnUse",
    x1: -1419.8308,
    y1: 171.8589,
    x2: -1418.1517,
    y2: 168.3835,
    gradientTransform: "matrix(-0.9976 6.960000e-02 6.960000e-02 0.9976 -1390.4418 58.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131329521002501983900000003052932883260080770_)"
    },
    d: "M37.6,128.5l0.1,1.8c0,0.1-0.6,0.3-1,0.1 l-0.3-1.7L37.6,128.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147940878906373063110000005070965332853305760_",
    gradientUnits: "userSpaceOnUse",
    x1: -1194.9614,
    y1: 263.3035,
    x2: -1190.8954,
    y2: 263.3035,
    gradientTransform: "matrix(-0.977 0.2135 0.2135 0.977 -1170.3707 127.8579)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147940878906373063110000005070965332853305760_)"
    },
    d: "M49.5,129.8c-0.3,0.3-0.3,0.8-0.1,1 c0.2,0.3,0.5,0.1,1.4,0.2c1,0.1,1.2,0.3,1.9,0.2c0.3-0.1,0.8-0.2,0.8-0.4c0-0.1-0.2-0.2-1-0.5c-1.1-0.4-1.1-0.5-1.4-0.5 C50.5,129.6,49.9,129.5,49.5,129.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057865052936233504640000009143419692244348346_",
    gradientUnits: "userSpaceOnUse",
    x1: -1340.3701,
    y1: 217.0192,
    x2: -1338.6555,
    y2: 213.4703,
    gradientTransform: "matrix(-0.9894 0.1455 0.1455 0.9894 -1306.8752 110.7828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057865052936233504640000009143419692244348346_)"
    },
    d: "M50.3,128.3l0.4,1.7c0,0.1-0.6,0.4-1,0.1 l-0.6-1.6L50.3,128.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071531777294759782030000018055227081393077680_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.3031,
    y1: 30.7244,
    x2: 377.4578,
    y2: 6.2764,
    gradientTransform: "matrix(0.9986 5.310000e-02 -5.310000e-02 0.9986 -333.7876 72.0004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071531777294759782030000018055227081393077680_)"
    },
    d: "M47.8,92.3c-0.2,5.5-0.2,11.7,0.4,18.4 c0.5,6.7,1.5,12.7,2.5,18c-0.6,0.1-1.3,0.3-1.9,0.4c-1.5-1.6-3.4-4-4.2-7.3c-0.5-2.1-0.2-3.1-0.5-5.7c-0.4-4-1.5-6.2-2.6-9.5 c-1-3-2.1-7.3-2.5-13C41.9,93.2,44.9,92.7,47.8,92.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078002420207838321200000000655355220968031371_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.6212,
    y1: 31.4704,
    x2: 375.7759,
    y2: 7.0225,
    gradientTransform: "matrix(0.9986 5.310000e-02 -5.310000e-02 0.9986 -333.7876 72.0004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464143"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000078002420207838321200000000655355220968031371_)"
    },
    d: "M46.9,117.9 c-0.7-2.8-2-3.5-2.1-6.1c0-1.8,0.6-2,0.6-3.8c-0.1-2.7-1.6-4.1-2.4-5.8c-0.8-1.8-1.2-4.6,1.1-9.4c-1.7,0.3-3.4,0.5-5.1,0.8 c0.4,5.7,1.5,10.1,2.5,13c1.1,3.3,2.2,5.5,2.6,9.5c0.2,2.5,0,3.6,0.5,5.7c0.8,3.3,2.7,5.8,4.2,7.3c0.2,0,0.3-0.1,0.5-0.1 c-1.6-1.9-2.2-3.7-2.4-5.1C46.7,121.7,47.6,120.7,46.9,117.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176759171598585587480000014880665856019243703_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.1696,
    y1: 166.0583,
    x2: 64.3243,
    y2: 141.6105,
    gradientTransform: "matrix(0.9976 -6.960000e-02 6.960000e-02 0.9976 -40.3109 -35.7716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176759171598585587480000014880665856019243703_)"
    },
    d: "M41.5,92c-0.8,7-1.4,14-2.1,21.3 c-0.5,5.4-0.9,10.8-1.3,16c-0.6,0-1.3,0.1-1.9,0.1c-0.6-1.2-1.3-3-1.7-5.3c-0.5-2.8-0.3-4.4-0.4-7.2c-0.2-3.2-0.6-3.9-1.3-8 c-1.3-8.2-2-12.4,0.1-14.8C33.6,93.3,35.7,91.4,41.5,92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168113463595788310590000012977349890883700156_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.7372,
    y1: 99.5363,
    x2: 41.6652,
    y2: 75.3493,
    gradientTransform: "matrix(1 -2.000000e-04 2.000000e-04 1 1.222 -1.0611)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168113463595788310590000012977349890883700156_)"
    },
    d: "M28.1,76.3c-0.8-2.2,0.5-4.7,2.8-5.2 c2.6-0.6,5.8-0.9,9.4-0.8c3.2,0.1,5.9,0.6,8.2,1.2c0.3,0.1,0.5,0.3,0.6,0.6c0.3,1.6,0.6,3.2,0.9,4.8c0.1,1.8,0.1,4.1-0.1,7 c-0.2,2.8-0.4,2.9-0.8,6.8c-0.7,6.5-0.4,8.2-1.7,9c-0.8,0.5-1.2-0.1-5.5-0.5c-2.9-0.3-4.4-0.4-5.9,0.1c-2,0.7-2.7,1.8-3.5,1.4 c-0.8-0.4-0.9-1.7-1-4.1c-0.1-3.7-0.1-6.2-0.2-7.1c-0.1-4.1-1.1-7.2-2.4-11.2C28.6,77.6,28.3,76.9,28.1,76.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129193725730914550910000008673437103617655954_",
    gradientUnits: "userSpaceOnUse",
    x1: 603.2014,
    y1: -692.3744,
    x2: 603.5887,
    y2: -702.6913,
    gradientTransform: "matrix(0.8945 0.4469 -0.4469 0.8945 -811.1749 423.9521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129193725730914550910000008673437103617655954_)"
    },
    d: "M39.9,66.2c0,1-0.2,1.8-0.3,2.4 c-0.2,0.6-0.3,0.8-0.4,0.9c-0.2,0.2-0.5,0.3-2,0.6c-0.8,0.2-0.9,0.1-0.9,0.2c-0.1,0.4,2,1.8,4.3,1.6c1.4-0.1,2.7-0.8,2.6-1.3 c-0.1-0.4-1.5-0.3-1.8-1c-0.3-0.5,0.1-1.3,0.5-1.9C41.6,67.2,40.2,67,39.9,66.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014615160819044212800000010648192990423293837_",
    gradientUnits: "userSpaceOnUse",
    x1: -1886.7664,
    y1: -183.5425,
    x2: -1889.3925,
    y2: -190.2122,
    gradientTransform: "matrix(-0.9988 -4.940000e-02 -4.940000e-02 0.9988 -1855.2408 161.5349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014615160819044212800000010648192990423293837_)"
    },
    d: "M42.4,66.8c0.4-0.4,0.4-1.2,0.1-1.7 c-0.3-0.4-0.8-0.5-1.1-0.6c-0.9-0.1-2,0.2-2.4,1c-0.3,0.5,0.2,1.5,0.3,1.7c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.2,0.5,0.6,1,1.2 c0-0.2,0.1-0.4,0.2-0.6c0-0.1,0.2-0.4,0.5-0.7C41.7,67,42.1,67.2,42.4,66.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109751912342240679400000013245659284656033469_",
    gradientUnits: "userSpaceOnUse",
    x1: -260.5785,
    y1: -142.4982,
    x2: -260.6993,
    y2: -132.768,
    gradientTransform: "matrix(0.9999 -1.180000e-02 1.180000e-02 0.9999 303.1002 206.1357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109751912342240679400000013245659284656033469_)"
    },
    d: "M39.8,68.3c0,0,0.5,1,1.7,1 c1,0,1.3-2.3,0.7-2.9c-0.2-0.2-0.7-0.3-1-0.2c-0.2,0-0.3,0.1-0.6,0.2c-0.3,0.1-0.4,0-0.5,0.1c-0.1,0.1-0.2,0.3-0.1,1 c-0.2-0.2-0.4-0.3-0.6-0.2c0,0-0.1,0.1-0.1,0.1C39.1,67.7,39.3,68.1,39.8,68.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072964910791887064730000011765973261039807389_",
    gradientUnits: "userSpaceOnUse",
    x1: -1887.5685,
    y1: -183.223,
    x2: -1890.1974,
    y2: -189.8997,
    gradientTransform: "matrix(-0.9988 -4.940000e-02 -4.940000e-02 0.9988 -1855.2408 161.5349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072964910791887064730000011765973261039807389_)"
    },
    d: "M40,66.4c0,0-0.1,0.2-0.1,0.5 c0,0.5,0.4,1.2,1,1.2c0.3,0,0.4-0.1,0.9-0.2c0.3,0,0.6,0,0.8,0.1c0.1,0.6-0.1,1.1-0.4,1.4c-0.4,0.3-0.9,0.1-1.1,0 c-0.1-0.1-0.6-0.2-0.8-0.7c-0.2-0.5,0-0.7-0.2-1c-0.1-0.2-0.3-0.2-0.5-0.5c0-0.1-0.1-0.2-0.1-0.2C39.5,66.7,39.9,66.3,40,66.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111156663334946826590000013887334415454782372_",
    gradientUnits: "userSpaceOnUse",
    x1: -1890.1414,
    y1: -187.2459,
    x2: -1890.0046,
    y2: -186.0272,
    gradientTransform: "matrix(-0.9988 -4.940000e-02 -4.940000e-02 0.9988 -1855.2408 161.5349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111156663334946826590000013887334415454782372_)"
    },
    d: "M42.1,68.2c0,0-0.2,0.1-0.6,0.1 c0,0,0,0,0,0c0,0,0.2,0.2,0.5,0.2C42.1,68.4,42.2,68.3,42.1,68.2C42.2,68.2,42.1,68.2,42.1,68.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088844078454173255290000004911869341511218852_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1878,
    y1: 98.3139,
    x2: 49.2337,
    y2: 63.5487,
    gradientTransform: "matrix(1 -2.000000e-04 2.000000e-04 1 1.222 -1.0611)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088844078454173255290000004911869341511218852_)"
    },
    d: "M45.5,97.6c-2.1-0.9-2.1-2.8-4.1-3.6 c-2.8-1.1-6,1.5-6.5,0.8c-0.5-0.8,3.2-3.1,2.7-5.3c-0.4-1.8-3-1.5-4.4-4c-1.3-2.3,0-4.5-1.2-5.3c-0.4-0.3-1.2-0.4-2.6,0.2 c1,3.1,1.7,5.8,1.7,9.1c0,0.9,0,3.4,0.2,7.1c0.1,2.4,0.2,3.7,1,4.1c0.8,0.4,1.5-0.8,3.5-1.4c1.5-0.5,2.9-0.4,5.9-0.1 c4.3,0.4,4.6,1,5.5,0.5c0.6-0.3,0.8-0.8,1-1.8C47.3,98,46.4,98,45.5,97.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149382534121882362880000005425811988938444203_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.1378,
    y1: 75.0722,
    x2: 40.0685,
    y2: 89.6858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464143"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149382534121882362880000005425811988938444203_)"
    },
    d: "M45.6,81.2c0,0.2-0.2,0.4-0.4,0.4 l-6,0.6L37,82.4l0,0c-0.1,0-0.2,0-0.3-0.1l-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.3V76l0.7,0l8.8-0.6l0,2l0,3.5L45.6,81.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111165156943779374730000003507784630633226632_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.2784,
    y1: 82.8606,
    x2: 40.8819,
    y2: 81.4126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111165156943779374730000003507784630633226632_)"
    },
    d: "M45.6,81.2L45.6,81.2 c0,0.2-0.2,0.4-0.4,0.4L37,82.4l0,0c-0.1,0-0.2,0-0.3-0.1l-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.3v-0.4c0,0.1,0.1,0.2,0.2,0.3l0.4,0.2 C36.8,82,36.9,82,37,82l0,0l8.2-0.8c0.2,0,0.4-0.2,0.4-0.4L45.6,81.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050623230549352405370000000948233075058963108_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.7326,
    y1: 76.2851,
    x2: 43.1614,
    y2: 82.9195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050623230549352405370000000948233075058963108_)"
    },
    d: "M45.6,77.4c0,0.2-0.2,0.3-0.4,0.3 L37,78.5c-0.1,0-0.2,0-0.3-0.1l-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.3V76l9.5-0.7L45.6,77.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127032825909662347700000004664350824508465852_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.1321,
    y1: 79.2116,
    x2: 37.0326,
    y2: 79.2116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3C5CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADA0A6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000127032825909662347700000004664350824508465852_)"
    },
    d: "M37,76.3v6.1l0,0 c-0.1,0-0.2,0-0.3-0.1l-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.3l0-5.9l0.7,0C36.9,76.1,37,76.2,37,76.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124129453966512965230000007360547481984777407_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.1369,
    y1: 75.751,
    x2: 45.6139,
    y2: 75.751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124129453966512965230000007360547481984777407_)"
    },
    d: "M36.3,76.3c-0.1,0-0.1-0.2-0.1-0.3 c0-0.1,0.1-0.2,0.2-0.2l8.3-0.8c0.3,0,0.6,0,0.8,0.2c0.1,0.1,0.2,0.2,0.1,0.3s-0.1,0.2-0.2,0.2l-8,0.8 C37,76.5,36.6,76.5,36.3,76.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037679153587549006150000010132951558298608778_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.8898,
    y1: 74.9738,
    x2: 42.1787,
    y2: 74.9738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000037679153587549006150000010132951558298608778_)"
    },
    points: "38.9,75.6 39.6,74.5 41.4,74.4  42.2,75.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106837098639300852870000002820682083400108173_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5685,
    y1: 74.8704,
    x2: 36.7469,
    y2: 77.5467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106837098639300852870000002820682083400108173_)"
    },
    d: "M37,75.6V76h0c0,0.1,0.4,0.2,0.9,0.2 c0.5,0,0.9-0.1,0.9-0.2h0v-0.4H37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021088297782606313970000013056759909754700184_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.0387,
    y1: 75.5818,
    x2: 38.8393,
    y2: 75.5818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000021088297782606313970000013056759909754700184_)"
    },
    cx: 37.9,
    cy: 75.6,
    rx: 0.9,
    ry: 0.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "39.5,76.3 40.2,75.3 42,75.1 42.8,76  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135677716828097838920000007793112540362389144_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.8898,
    y1: 75.4097,
    x2: 40.192,
    y2: 75.4097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000135677716828097838920000007793112540362389144_)"
    },
    points: "38.9,75.6 39.5,76.3 40.2,75.3  39.6,74.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003069495414400886890000006898206422447439504_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.5203,
    y1: 75.0962,
    x2: 41.6673,
    y2: 77.0303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000003069495414400886890000006898206422447439504_)"
    },
    points: "39.5,76.3 42.8,76 43,76.2  39.6,76.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101090354562553806300000005852897306629340573_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.3887,
    y1: 77.2725,
    x2: 43.4598,
    y2: 77.2725
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3E9E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1D1C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000101090354562553806300000005852897306629340573_)"
    },
    points: "39.6,76.6 39.4,78.3 43.5,77.6  43,76.2  "
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "39.3,78.3 39.5,76.3 39.6,76.6 39.4,78.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150822603490867312190000017192129743798570118_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.0679,
    y1: 74.3431,
    x2: 39.4052,
    y2: 76.9856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000150822603490867312190000017192129743798570118_)"
    },
    points: "39.3,78.3 39.5,76.3 39.6,76.6  39.4,78.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031177969147772798080000016412925956682205317_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.5271,
    y1: 76.8893,
    x2: 43.4788,
    y2: 82.759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031177969147772798080000016412925956682205317_)"
    },
    d: "M44.5,79.1c0.1,0.2,0.1,0.4,0.1,0.7 c0,1.6-1.3,2.8-2.8,2.8c-0.3,0-0.5,0-0.8-0.1l-0.3,0.2l-0.2-0.2l-0.6-0.6c-0.1-0.1-0.2-0.1-0.2-0.2l0,0 c-0.4-0.5-0.7-1.2-0.7-1.9c0-0.6,0.2-1.1,0.4-1.5c0,0,0,0,0,0c0.5-0.8,1.4-1.3,2.4-1.3c0.4,0,0.8,0.1,1.1,0.2 c0.3,0.2,0.7,0.4,0.9,0.6l1,1L44.5,79.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004534547752292728600000012504025372469375107_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.9583,
    y1: 80.3425,
    x2: 40.5062,
    y2: 80.3425
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000004534547752292728600000012504025372469375107_)"
    },
    d: "M40.5,82.4l-0.6-0.6 c-0.1-0.1-0.2-0.1-0.2-0.2l0,0c-0.4-0.5-0.7-1.2-0.7-1.9c0-0.6,0.2-1.1,0.4-1.5c0,0-0.4,1.5,0.2,2c0.6,0.5,0.7,1.3,0.9,2.1 C40.5,82.4,40.5,82.4,40.5,82.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121247945838923397660000003079196490928398003_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.0185,
    y1: 80.7961,
    x2: 45.6665,
    y2: 80.7961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464143"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121247945838923397660000003079196490928398003_)"
    },
    d: "M45.7,80.8c0,1.1-0.6,2.1-1.6,2.5 c-0.4,0.2-0.8,0.3-1.2,0.3c-1.6,0-2.8-1.3-2.8-2.8c0-0.8,0.3-1.5,0.8-2c0.5-0.5,1.2-0.8,2-0.8C44.4,78,45.7,79.2,45.7,80.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084512669984541981280000005553918593117727631_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.0185,
    y1: 81.2161,
    x2: 44.0882,
    y2: 81.2161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000084512669984541981280000005553918593117727631_)"
    },
    d: "M44.1,83.3 c-0.4,0.2-0.8,0.3-1.2,0.3c-1.6,0-2.8-1.3-2.8-2.8c0-0.8,0.3-1.5,0.8-2c0.3,0.1,0.6,0.4,0.8,1C42,81.1,42.2,83.3,44.1,83.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173126705171451554210000014312998592324689061_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.5614,
    y1: 82.9528,
    x2: 43.5441,
    y2: 82.9011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B3138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#241F21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173126705171451554210000014312998592324689061_)"
    },
    d: "M45,80.8c0,1.2-1,2.2-2.2,2.2 c-0.7,0-1.3-0.3-1.7-0.8c-0.3-0.4-0.5-0.8-0.5-1.3c0-1.2,1-2.2,2.2-2.2c0.5,0,1,0.2,1.3,0.5C44.7,79.5,45,80.1,45,80.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152971534156484401060000012847489246278599324_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.6808,
    y1: 80.6224,
    x2: 44.6568,
    y2: 80.6224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96888E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#706369"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152971534156484401060000012847489246278599324_)"
    },
    d: "M44.7,80.4c0,1.2-1,2.2-2.2,2.2 c-0.5,0-1-0.2-1.3-0.5c-0.3-0.4-0.5-0.8-0.5-1.3c0-1.2,1-2.2,2.2-2.2c0.5,0,1,0.2,1.3,0.5C44.5,79.5,44.7,79.9,44.7,80.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022537901341568003980000006552470558852331701_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.5982,
    y1: 79.8934,
    x2: 41.6499,
    y2: 79.9279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3C5CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADA0A6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000022537901341568003980000006552470558852331701_)"
    },
    cx: 42.6,
    cy: 80.6,
    r: 1
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 42.9,
    cy: 80.3,
    r: 0.5
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M44.1,76.9c-0.1,0-0.3-0.1-0.3-0.2l0,0c0-0.2,0.1-0.3,0.2-0.3l0.9-0.1c0,0,0,0,0,0c0.1,0,0.3,0.1,0.3,0.2 l0,0c0,0.2-0.1,0.3-0.2,0.3L44.1,76.9C44.1,76.9,44.1,76.9,44.1,76.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.2,76.6c0,0.1-0.1,0.2-0.2,0.2l-0.9,0.1c-0.1,0-0.2-0.1-0.2-0.2l0,0c0-0.1,0.1-0.2,0.2-0.2l0.9-0.1 C45.1,76.3,45.2,76.4,45.2,76.6L45.2,76.6z"
  })), /*#__PURE__*/React.createElement("g", null, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 43.2,
    cy: 75.4,
    rx: 0.6,
    ry: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6,
    y: 75.1,
    className: "st17",
    width: 1.1,
    height: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129920131490587070950000001016947676448813470_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.0139,
    y1: 74.8661,
    x2: 44.1046,
    y2: 76.7516
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000129920131490587070950000001016947676448813470_)"
    },
    cx: 43.2,
    cy: 75.1,
    rx: 0.6,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 44.5,
    cy: 75.5,
    rx: 0.6,
    ry: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.9,
    y: 75.2,
    className: "st17",
    width: 1.1,
    height: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173882559066645082370000012356487114968315836_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.9309,
    y1: 74.3356,
    x2: 45.0216,
    y2: 76.2212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4BDAC"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000173882559066645082370000012356487114968315836_)"
    },
    cx: 44.5,
    cy: 75.2,
    rx: 0.6,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029735610454619781010000016420521300176949679_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.1321,
    y1: 80.6012,
    x2: 39.2833,
    y2: 80.6012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85A0B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#47607E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000029735610454619781010000016420521300176949679_)"
    },
    d: "M39.3,82.2L37,82.4v0l0,0 c-0.1,0-0.2,0-0.3-0.1l-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.3v-1.6c0.6-0.6,0.5-1.8,0.9-1.5c0,0,0.1,1.7,0.8,1.7 C38.6,80.5,39.1,81,39.3,82.2C39.3,82.1,39.3,82.2,39.3,82.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154391421705678442860000015509771338947227017_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.2243,
    y1: 76.1634,
    x2: 47.5079,
    y2: 83.1334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154391421705678442860000015509771338947227017_)"
    },
    d: "M47.4,79.3L47,79.1 c0-0.5-0.1-1.4-0.6-1.8c-0.7-0.6-1.6-0.9-1.9-0.8c-0.3,0.2-0.1,0.8,0.6,1.4c0.7,0.7,0.5,1.7,1,2.1c0.1,0.1,0.2,0.1,0.3,0.1 l0.5,0.5L47.4,79.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012466056458186436850000005846697865958732946_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.614,
    y1: 81.5282,
    x2: 53.8083,
    y2: 88.4688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012466056458186436850000005846697865958732946_)"
    },
    d: "M47.3,79.2c3.9,1.6,5.6,3.9,6.3,5.1 c0.4,0.8,1.2,2.1,0.7,2.9c-0.5,0.8-1.8,0.8-2.4,0.7c-3.3-0.5-4.9-6.7-5-7.3L47.3,79.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049180139707553509030000015528727643597127315_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.5916,
    y1: 81.9492,
    x2: 30.2245,
    y2: 85.4673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049180139707553509030000015528727643597127315_)"
    },
    d: "M24.6,82.6c-0.8,0.7-2,1.9-1.8,3.1 c0.2,1.1,1.7,1.6,2.4,1.7c3.8,0.6,7.5-6.1,7.9-6.8l0.1-1.6C28.4,79.5,25.7,81.5,24.6,82.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146476024313433009950000011054529986434398387_",
    gradientUnits: "userSpaceOnUse",
    x1: 3946.7996,
    y1: 627.5488,
    x2: 3948.7588,
    y2: 633.5282,
    gradientTransform: "matrix(-0.9554 -0.2953 -0.2953 0.9554 3992.3779 643.2237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146476024313433009950000011054529986434398387_)"
    },
    d: "M32.9,79.1c0,0,1.1-1.6,2.2-1.6 c1.1,0,2.1,0.5,2.2,0.9c0.1,0.4-0.5,0.7-1.6,0.7c-1.1,0-1.8,1.1-2.5,1C32.5,80.1,32.9,79.1,32.9,79.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069372504768468570350000000985562065514441104_",
    gradientUnits: "userSpaceOnUse",
    x1: 2615.8303,
    y1: 33.0449,
    x2: 2640.0508,
    y2: 77.9665,
    gradientTransform: "matrix(-1 0 0 1 2732.1519 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF9F8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E68273"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069372504768468570350000000985562065514441104_)"
    },
    d: "M92,45.4c0,8,7.8,14.4,17.5,14.5 c9.9,0,18-6.6,18-14.8c0-8.2-8.1-14.7-18-14.5C99.8,30.8,92,37.4,92,45.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083784275520656263680000003362286956126592447_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.9702,
    y1: 56.7688,
    x2: 123.5416,
    y2: 51.7812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF9F8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E68273"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083784275520656263680000003362286956126592447_)"
    },
    d: "M92,45.4c0,8,7.8,14.4,17.5,14.5 c9.9,0,18-6.6,18-14.8c0-8.2-8.1-14.7-18-14.5C99.8,30.8,92,37.4,92,45.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061462957300059297900000015062128576550575549_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.3303,
    y1: 70.6521,
    x2: 116.9017,
    y2: 65.6645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF9F8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E68273"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061462957300059297900000015062128576550575549_)"
    },
    d: "M102,57.6c0,0-4.3,4.7-10.5,0.8L90.3,57 c0,0,6.3-3.2,6.4-5.9L102,57.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031889731186717358770000005287230543288822701_",
    gradientUnits: "userSpaceOnUse",
    x1: 2617.0791,
    y1: 31.7199,
    x2: 2641.2996,
    y2: 76.6416,
    gradientTransform: "matrix(-1 0 0 1 2732.1519 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031889731186717358770000005287230543288822701_)"
    },
    d: "M90.8,44c0,8,7.8,14.4,17.5,14.5 c9.9,0,18-6.6,18-14.8s-8.1-14.7-18-14.5C98.5,29.4,90.8,36.1,90.8,44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137823924328446189860000004450378130392747419_",
    gradientUnits: "userSpaceOnUse",
    x1: 2617.0791,
    y1: 31.7199,
    x2: 2641.2996,
    y2: 76.6416,
    gradientTransform: "matrix(-1 0 0 1 2732.1519 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137823924328446189860000004450378130392747419_)"
    },
    d: "M90.8,44c0,8,7.8,14.4,17.5,14.5 c9.9,0,18-6.6,18-14.8s-8.1-14.7-18-14.5C98.5,29.4,90.8,36.1,90.8,44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022556637568712064180000017203092601655683503_",
    gradientUnits: "userSpaceOnUse",
    x1: 3271.7832,
    y1: 856.6409,
    x2: 3295.4192,
    y2: 900.4789,
    gradientTransform: "matrix(-0.9879 -0.1549 -0.1549 0.9879 3479.0745 -307.5645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022556637568712064180000017203092601655683503_)"
    },
    d: "M100.8,56.3c0,0-4.3,4.7-10.5,0.8 c0,0,5-3.1,5.2-7.3L100.8,56.3z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.4,40.1L98.4,40.1c0.7-2.1,2.6-3.5,4.8-3.6c2.8,0,5.1,2.4,5.1,5.5c0-3.1,2.3-5.6,5.2-5.6 c2.2,0,4.1,1.4,4.9,3.5l0,0c2.9,7.4-10.1,14.4-10.1,14.4S95.5,47.4,98.4,40.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st85"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123425776238305799520000007939647971984445867_",
    gradientUnits: "userSpaceOnUse",
    x1: 2610.3689,
    y1: 34.2811,
    x2: 2634.1985,
    y2: 82.1013,
    gradientTransform: "matrix(-1 0 0 1 2732.1519 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F89F8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123425776238305799520000007939647971984445867_)"
    },
    d: "M104,54.8c2.1-4.3,0-8.3,2.9-11.2 c2.9-2.9,6.8-0.3,10.9-2.6c1.6-0.9,3.4-2.7,4.8-6.3c2.3,2.5,3.7,5.6,3.7,9c0,8.2-8.1,14.8-18,14.8c-2.2,0-4.4-0.4-6.3-1 C102.9,56.6,103.5,55.7,104,54.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.665a45fea635c8a31ac4c8e896f29767.svg";
export { ForwardRef as ReactComponent };